__turbopack_context__.v({
  "acheivername": "upsc-sociology-optional-module__i0ctSq__acheivername",
  "acheivername1": "upsc-sociology-optional-module__i0ctSq__acheivername1",
  "acheiverrank": "upsc-sociology-optional-module__i0ctSq__acheiverrank",
  "acheiverrank1": "upsc-sociology-optional-module__i0ctSq__acheiverrank1",
  "acheiverrank2": "upsc-sociology-optional-module__i0ctSq__acheiverrank2",
  "acheiverrank3": "upsc-sociology-optional-module__i0ctSq__acheiverrank3",
  "acheiverrank4": "upsc-sociology-optional-module__i0ctSq__acheiverrank4",
  "acheivertitle": "upsc-sociology-optional-module__i0ctSq__acheivertitle",
  "ansheet": "upsc-sociology-optional-module__i0ctSq__ansheet",
  "bgboxbg": "upsc-sociology-optional-module__i0ctSq__bgboxbg",
  "captcha": "upsc-sociology-optional-module__i0ctSq__captcha",
  "checkboxcontent": "upsc-sociology-optional-module__i0ctSq__checkboxcontent",
  "classesborder": "upsc-sociology-optional-module__i0ctSq__classesborder",
  "contactbox": "upsc-sociology-optional-module__i0ctSq__contactbox",
  "contactboxheight": "upsc-sociology-optional-module__i0ctSq__contactboxheight",
  "contactsubcontent": "upsc-sociology-optional-module__i0ctSq__contactsubcontent",
  "gshad": "upsc-sociology-optional-module__i0ctSq__gshad",
  "img": "upsc-sociology-optional-module__i0ctSq__img",
  "imgboxbelow": "upsc-sociology-optional-module__i0ctSq__imgboxbelow",
  "invalidCheck2": "upsc-sociology-optional-module__i0ctSq__invalidCheck2",
  "mainshead": "upsc-sociology-optional-module__i0ctSq__mainshead",
  "mbtableheading": "upsc-sociology-optional-module__i0ctSq__mbtableheading",
  "medalicon": "upsc-sociology-optional-module__i0ctSq__medalicon",
  "mobhead": "upsc-sociology-optional-module__i0ctSq__mobhead",
  "mobilemaillinks": "upsc-sociology-optional-module__i0ctSq__mobilemaillinks",
  "more": "upsc-sociology-optional-module__i0ctSq__more",
  "normalbutton": "upsc-sociology-optional-module__i0ctSq__normalbutton",
  "normalbutton2": "upsc-sociology-optional-module__i0ctSq__normalbutton2",
  "pagemaintitle": "upsc-sociology-optional-module__i0ctSq__pagemaintitle",
  "paybill": "upsc-sociology-optional-module__i0ctSq__paybill",
  "paybills": "upsc-sociology-optional-module__i0ctSq__paybills",
  "redunderline": "upsc-sociology-optional-module__i0ctSq__redunderline",
  "sectiontitle": "upsc-sociology-optional-module__i0ctSq__sectiontitle",
  "sectiontitle1": "upsc-sociology-optional-module__i0ctSq__sectiontitle1",
  "sectiontitle2": "upsc-sociology-optional-module__i0ctSq__sectiontitle2",
  "subhead": "upsc-sociology-optional-module__i0ctSq__subhead",
  "tableheading": "upsc-sociology-optional-module__i0ctSq__tableheading",
  "tablepara": "upsc-sociology-optional-module__i0ctSq__tablepara",
  "tablepara1": "upsc-sociology-optional-module__i0ctSq__tablepara1",
  "tablescroll": "upsc-sociology-optional-module__i0ctSq__tablescroll",
  "toppersupsc": "upsc-sociology-optional-module__i0ctSq__toppersupsc",
  "viewbutton": "upsc-sociology-optional-module__i0ctSq__viewbutton",
});
